import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import type * as rxjs from 'rxjs'

import * as gql from '../../gql'

import type { Context } from './types'

/**
 * API used by the records bulk responsible persons workflow
 */
@ngCore.Injectable()
export class Api {
  /**
   * Makes the given employees responsible for every record in the context.
   */
  public update({
    context,
    employeeIds,
    primaryEmployeeId,
  }: Api.Update.Params): rxjs.Observable<undefined> {
    return gql.mutations.bulkUpdateResponsiblePersons.executor({
      ...context,
      employeeIds,
      primaryResponsiblePersonId: primaryEmployeeId,
    })
  }
}

export namespace Api {
  export namespace Update {
    /** {@link Context}, with the responsible persons to apply */
    export interface Params {
      readonly context: Context
      readonly employeeIds: readonly ents.extra.space.Employee.Id[]
      readonly primaryEmployeeId?: ents.extra.space.Employee.Id
    }
  }
}
